import { TooltipSwitch } from '@repo/videa-components/src/index';
import { useAtom, useAtomValue } from 'jotai';

import { usePreferences } from '../../../react-query/usePreferences';
import { isDevDashboardAtom, selectedDashboardAtom } from '../atoms';
import {
  DashboardMap,
  DashboardPriorityList,
  DashboardUrls,
} from '../constants';

import { DashboardTabs } from './DashboardTabs';

export const InsightsHeader = () => {
  const [isDevDashboard, setIsDevDashboard] = useAtom(isDevDashboardAtom);
  const selectedDashboard = useAtomValue(selectedDashboardAtom);

  const { data: prefs } = usePreferences();

  if (!prefs?.enableInsights) {
    return;
  }

  const defaultDashboard = DashboardPriorityList.find(
    (dashboard) =>
      prefs?.enableInsights && prefs?.enableInsights?.includes(dashboard),
  );

  if (!defaultDashboard) {
    return;
  }

  const currentDashboard = selectedDashboard || DashboardMap[defaultDashboard];

  return (
    <div className="vai-flex vai-justify-start vai-my-4 vai-mx-8 vai-gap-8 vai-h-12 vai-border-b-[1px] vai-w-[calc(100%-4rem)] vai-border-gray-200">
      <DashboardTabs currentDashboard={currentDashboard} />
      {prefs?.enableDevDashboards && DashboardUrls[currentDashboard]?.dev && (
        <TooltipSwitch
          checked={isDevDashboard}
          setChecked={setIsDevDashboard}
          shortLabel={isDevDashboard ? 'D' : 'P'}
          longLabel={isDevDashboard ? 'Dev Dashboard' : 'Prod Dashboard'}
        />
      )}
    </div>
  );
};
